import { render, staticRenderFns } from "./Record.vue?vue&type=template&id=7601796e&scoped=true&"
import script from "./Record.vue?vue&type=script&lang=js&"
export * from "./Record.vue?vue&type=script&lang=js&"
import style0 from "./Record.vue?vue&type=style&index=0&id=7601796e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7601796e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/rec-rich/lib/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7601796e')) {
      api.createRecord('7601796e', component.options)
    } else {
      api.reload('7601796e', component.options)
    }
    module.hot.accept("./Record.vue?vue&type=template&id=7601796e&scoped=true&", function () {
      api.rerender('7601796e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/main2/components/session/item/Record.vue"
export default component.exports